/* global Swiper */

( function () {
	"use strict";

	/* ── Convert any YouTube / Vimeo URL to an embeddable src ── */
	function getEmbedUrl( url ) {
		if ( ! url ) return null;

		/* youtube.com/watch?v=ID  |  youtu.be/ID  |  youtube.com/shorts/ID */
		var yt = url.match(
			/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
		);
		if ( yt ) return "https://www.youtube.com/embed/" + yt[ 1 ] + "?autoplay=1&rel=0";

		/* vimeo.com/ID */
		var vm = url.match( /vimeo\.com\/(?:.*\/)?(\d+)/ );
		if ( vm ) return "https://player.vimeo.com/video/" + vm[ 1 ] + "?autoplay=1";

		/* Already an embed URL */
		if ( url.indexOf( "embed" ) !== -1 ) {
			return url + ( url.indexOf( "?" ) !== -1 ? "&autoplay=1" : "?autoplay=1" );
		}

		return null;
	}

	/* ── Play-button click: replace wrapper content with iframe ── */
	document.addEventListener( "click", function ( e ) {
		var btn = e.target.closest( ".beneficiary-play-btn" );
		if ( ! btn ) return;

		var wrapper = btn.closest( ".beneficiary-video-wrapper" );
		if ( ! wrapper ) return;

		var videoUrl = wrapper.dataset.videoUrl;
		if ( ! videoUrl ) return;

		var embedSrc = getEmbedUrl( videoUrl );

		if ( embedSrc ) {
			wrapper.innerHTML =
				'<iframe src="' + embedSrc + '" ' +
				'style="position:absolute;inset:0;width:100%;height:100%;border:0;" ' +
				'allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
			wrapper.style.position = "relative";
		} else {
			window.open( videoUrl, "_blank", "noopener,noreferrer" );
		}
	} );

	/* ── Swiper init ── */
	function initBeneficiarySliders() {
		if ( typeof window.Swiper === "undefined" ) return;

		document
			.querySelectorAll( ".beneficiary-swiper:not(.swiper-initialized)" )
			.forEach( function ( el ) {
				var section = el.closest( ".beneficiary-slider-section" );
				if ( ! section ) return;

				new window.Swiper( el, {
					loop:          true,
					slidesPerView: 1,
					speed:         500,
					navigation: {
						prevEl:          section.querySelector( ".beneficiary-prev" ),
						nextEl:          section.querySelector( ".beneficiary-next" ),
						disabledClass:   "beneficiary-arrow-disabled",
					},
					a11y: {
						prevSlideMessage: "Previous slide",
						nextSlideMessage: "Next slide",
					},
				} );
			} );
	}

	if ( document.readyState === "loading" ) {
		document.addEventListener( "DOMContentLoaded", initBeneficiarySliders );
	} else {
		initBeneficiarySliders();
	}
} )();
